import http from "./http-auth";

export function InsertItem(data) {
  return http.post("/bio", data).then((res) => {});
}
export function DeleteItem(data) {
  return http.delete(`/bio/${data}`).then((res) => {});
}

export function UpdateItem(data) {
  return http.put(`/bio/${data.id}`, data).then((res) => {});
}

export function GetItem(data) {
  return http.get(`/bio/${data.id}`, data).then((res) => {});
}

export const GetAllItems = () => {
  return http.get("/bio");
};
